// extracted by mini-css-extract-plugin
export default {"root":"AllMarkets_root__-kEhu"};